// export const baseUrl ='https://tglpt.ghfz.1000rui.cn/guazhou/api'
// export const baseUrl='http://cpsweb.ghfz.1000rui.cn/api'
export const baseUrl = HOST_URL
console.log(DATE,'DATEDATEDATEDATEDATE',HOST_URL)
// export const DATES = DATE


// WEBPACK FOOTER //
// ./src/api/global.js